const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
  list.reduce((acc, next) => {
    const group = getKey(next)
    if (!acc[group]) acc[group] = []
    acc[group].push(next)
    return acc
  }, {} as Record<K, T[]>)

export default groupBy
